import React from 'react'
import Link from 'react-router-dom'

export default class Home extends React.Component {
    render() {
        return (
            <h1>Home Component!</h1>
        );
    }
}


// WEBPACK FOOTER //
// ./src/Home.jsx